// Room Housekeeping model
// import { layout as housekeeping } from "apps/HotelFrontdesk/reports/reportHouseKeeping";

const stateColors = {
  clean: ["bg-sky-200", "border-sky-400", "text-sky-700"],
  dirty: ["bg-rose-200", "border-rose-400", "text-rose-800"],
  not_authorized: ["bg-lime-200", "border-lime-500", "text-lime-700"],
  maintenance: ["bg-neutral-300", "border-neutral-500", "text-neutral-700"],
  inspected: ["bg-orange-300", "border-orange-600", "text-orange-800"],
};

function layout(props) {
  const ctxView = {
    model: "hotel.room",
    table_action: [], // options: ['open', 'delete', 'edit', 'add']
    form_action: ["edit"], // options: ['open', 'delete', 'edit', 'add']
    activeSearch: true,
    domain: [], // Options: null or valid domain
    orderBy: [["code", "ASC"]],
    selectable: "multi", // Options for table rows: null, multi, one
    // title: { field: "rec_name" },
    card_action: ["delete"],
    tags: {
      state: stateColors,
    },
    fields: {
      name: {
        type: "char",
        readOnly: true,
        searchable: true,
      },
      notes: { type: "text" },
      type_: {
        type: "many2one",
        model: "hotel.room.type",
        readOnly: true,
      },
      cleaning_type: {
        type: "many2one",
        model: "hotel.room.cleaning_type",
        readOnly: true,
      },
      location: {
        type: "many2one",
        model: "hotel.location",
        readOnly: true,
        filter: true,
      },
      housekeeping: {
        type: "many2one",
        model: "company.employee",
        readOnly: true,
      },
      state: {
        type: "char",
        label: false,
        readOnly: true,
        translate: true,
        tags: stateColors,
      },
      last_check_in: {
        type: "datetime",
        readOnly: true,
      },
      last_check_out: {
        type: "datetime",
        readOnly: true,
      },
      // add_room: {
      //   type: "button",
      //   button_method: "add_room",
      //   color: "amber",
      // },
    },
    list: [
      { name: "name", width: "15%" },
      { name: "cleaning_type", width: "15%" },
      { name: "type_", width: "25%" },
      { name: "location", width: "25%" },
      { name: "housekeeping", width: "25%" },
      {
        name: "state",
        width: "10%",
        widget: "circle",
      },
    ],
    form: [
      //   { name: "name", colSpan: "col-span-2", style: "font-bold text-lg" },
      //   { name: "state" },
      //   { name: "type_" },
      //   { name: "location" },
      //   { name: "check_out_widget" },
      //   { name: "check_in_widget" },
      //   { name: "cleaning_type" },
      //   { name: "last_clean" },
      //   {
      //     name: "buttons",
      //     type: "grid",
      //     elements: [
      //       { name: "clean" },
      //       { name: "not_authorized" },
      //       { name: "dirty" },
      //       { name: "maintenance" },
      //     ],
      //     colSpan: "col-span-2",
      //   },
      //   { name: "housekeeping" },
      //   { name: "notes" },
      // ],
      // cards: [
      //   { name: "name" },
      //   { name: "state" },
      //   { name: "type_" },
      //   { name: "cleaning_type" },
      //   { name: "last_clean" },
      //   { name: "housekeeping" },
      //   { name: "clean" },
      //   { name: "check_out_today" },
      //   { name: "notes" },
    ],
  };

  return ctxView;
}

export { layout };
